import BenchlingConfig from 'BenchlingConfig';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepConfig} from 'pipelines/PipelineTypes';
import {getTooManyStudiesMessage} from 'studies/typed/utils/analysis/analysisUtils';

import {AdditionalConfigValidationFunctions} from '../StepConfigValidationTypes';

/**
 * Validates draft config for the CREATE_PROCEDURE_DATASET step type, checking that
 * study seed items respect the study count limit.
 */
function validateDraftConfig(
  config: PipelineStepConfig<PipelineStepType.CREATE_PROCEDURE_DATASET, 0, 'draft'>
): Array<string> {
  const seedItems = config.seedItems;
  if (seedItems?.seedItemType !== 'STUDY') {
    return [];
  }

  const studyIds = seedItems.seedItemIds?.filter((id): id is string => id != null) ?? [];
  const errors: Array<string> = [];

  const limit = BenchlingConfig.STUDIES_PER_CROSS_STUDY_ANALYSIS_LIMIT;
  if (studyIds.length > limit) {
    errors.push(getTooManyStudiesMessage(limit, studyIds.length));
  }

  return errors;
}

export default {
  stepType: PipelineStepType.CREATE_PROCEDURE_DATASET,
  stepVersion: 0,
  validateDraftConfig,
} satisfies AdditionalConfigValidationFunctions<PipelineStepType.CREATE_PROCEDURE_DATASET, 0>;
